import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL UI STUFF
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'

import Payment from '../../../../assets/StandAlone/venti.svg'


export default class CardPayment extends React.Component {
   
	render(){
		return(
			
            <Grid container spacing="16" alignItems="flex-start" className={css(styles.MainDiv)}>
                <Grid item md={5} xs={10}>
                    <img className={css(styles.image)} src={Payment} alt=""/>
                </Grid>
                <Grid className={css(styles.textContainer)} item md={7} xs={12}>
                    <div>
                        <Typography variant="title" className={css(styles.title)}>
                        {this.props.title}      
                        </Typography>
                        <Typography variant="subheading" style={{color: 'white', fontWeight: '400'}}>
                            {this.props.subtitle}      
                        </Typography>
                        <Typography variant="body1" style={{color: 'white', fontWeight: '300'}}>
                            {this.props.text}      
                        </Typography>
                        <MainButton />
                    </div>
                </Grid>
            </Grid>
			)
	}
}
const MainButton = () =>
<a style={{textDecoration: 'none'}} target="_blank" href="https://venti.com.ar" rel="noopener noreferrer">
    <Button className={css(styles.introButton)}>
        SEE MORE
    </Button>
</a>

const styles = StyleSheet.create({
    MainDiv :{
        minWidth: 300,
        height: 'auto',
        textAlign:'left',
        background: 'linear-gradient(-69deg, #4D88FF, #457FDD)',
        boxShadow: 'rgba(50, 50, 93, 0.2) 0px 20px 40px, rgba(0, 0, 0, 0.07) 0px 8px 15px',
        borderRadius: 2,
          '@media (max-width: 768px)': {
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center', 
            marginBottom: '2em'    
        }

    },
    image : {
        width:'100%',
        maxHeight: '262px',
        marginTop: '-3em', 
        padding: '0 .5em', 
        pointerEvents: 'none'
    },
    textContainer : {
        marginTop: '4%',
        '@media (max-width: 768px)': {  
            marginTop: '0%',
        }
    },
    title : {
        color: 'white', fontWeight: '400', marginBottom: 8
    },
    introButton: {
        color: 'white',
        // background:'linear-gradient(-69deg, #FF6B4D, #D85944)',
        border: '.5px solid white',
        lineHeight: 0,
        marginTop: '5%',
        marginBottom: '7%',
        transition: 'all ease-in-out .2s',
        ':hover':{
            // transform: 'translate(0, -2px)',
            // boxShadow: '0 2px 10px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
    rightArrow: {
        backgroundColor: '#F7FCFF',
        color: '#457FDD',
        borderRadius: '188px',
        fontSize: '31px',
        padding: '5px',
        marginLeft: '15px'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/StandAloneSolutions/Cards/CardPayment.js